export { default as About } from "./About";
export { default as Home } from "./Home";
export { default as Contact } from "./Contact";
export { default as Main } from "./Main";
export { default as Search } from "./Search";
export { default as Article } from "./Article";
export { default as Viewnotfound } from "./Viewnotfound";
